import React, { useEffect, useState } from "react";

import {
  A,
  Bg,
  Hello,
  P,
  Position,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
  Spanfollow,
} from "../../../styles";
import Menu from "./menu";
import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import Footer from "../S5_Footer";
import SlideBar from "../../../Componenets/SlideBar";
// import Loading from "./loading";

const Background = styled.div`
  background-image: url("/images/bg.png");
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0 0 0 40px;
  @media screen and (max-width: 599px) {
    padding: 0;
  }
`;
const CustomGrid = styled(Grid)`
  align-items: center;
  min-height: calc(100vh - 30px);
`;
const Span = styled.span`
  font-size: 80px;
  font-family: "Glitch-inside";
  color: #a2ffec;
  text-shadow: 0 0 10px #00fdca;
  @media (max-width: 599px) {
    font-size: 40px;
  }
`;

const TwoButtons = styled.div`
  margin: 0px 0px 0 0;
  display: flex;
  align-items: center;
  @media screen and (max-width: 899px) {
    /* margin-top: 70px; */
  }
`;
const BuyNow = styled.a`
  text-decoration: none;
  font-family: "Lucida-Regular";
  cursor: pointer;
  color: #000000;
  background-image: url("/images/button-left.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  padding: 40px 30px 40px 30px;
  font-size: 18px;
  margin: 0 10px;
`;
const Chart = styled.a`
  text-decoration: none;
  cursor: pointer;
  font-family: "Lucida-Regular";
  color: #ffffff;
  background-image: url("/images/button-right.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  padding: 40px 30px 40px 30px;
  font-size: 13px;
`;
const VideoBK = styled.video`
  mix-blend-mode: screen;
  display: block;
  height: auto;
  object-fit: cover;
  width: 100%;
  /* position: absolute; */
  z-index: 1;
`;
const Index = () => {
  return (
    <div>
      <SlideBar />
      <Menu />
      <Background>
        <SectionWrapper>
          <Container maxWidth="xl">
            <CustomGrid container>
              <Grid xs={12} md={6}>
                <SectionHeading>
                  <Span>H</Span>EX<Span>V</Span>OLT<Span>I</Span>NU
                </SectionHeading>
                <P maxWidth="80%" pt630="20PX 0">
                  HexVoltInu is a micro market cap token made for degens who
                  won’t settle on small gains. With our upcoming fair launch,
                  you can sit back and watch your portfolio grow as HexVoltInu
                  hits new ATHs.
                </P>
                <TwoButtons>
                  <BuyNow
                    href="https://app.uniswap.org/#/swap?outputCurrency=0x7D4979302Eada5eb7888Ba4CFc3Fa712Cb4Ad110&chain=mainnet"
                    target="blank"
                  >
                    Buy Now
                  </BuyNow>
                  <Chart
                    href="https://www.dextools.io/app/ether/pair-explorer/0x9980319eaf49a16811a41f96ec1d7c2e2732bda7"
                    target="blank"
                  >
                    View Chart
                  </Chart>
                </TwoButtons>
              </Grid>
              <Grid xs={12} md={6}>
                <VideoBK autoPlay loop muted>
                  <source src="/images/hexfire.mp4" type="video/mp4" />
                </VideoBK>
              </Grid>
            </CustomGrid>
            {/* <Footer /> */}
          </Container>
        </SectionWrapper>
      </Background>
    </div>
  );
};

export default Index;
